import axios from "axios";
import {removeSlash} from './api';
import config from "./config";

class APIForm {
    static async getFormPdf(data) {
        return new Promise(function (resolve, reject) {
            axios.post(config.formsApi + "/data/pdf-preview-ecs/", data,
                {
                    responseType: "blob",
                    mode: "no-cors",
                    headers: {"Access-Control-Allow-Origin": "*"},
                }).then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async getDictForm(dictName, query) {
        return new Promise(function (resolve, reject) {
            axios.get(config.formsApi + `/dict/${dictName}?size=-1&sort=name&dictType=forms&query=${encodeURIComponent(query)}`).then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async getSaveForm(data, patientId, formName) {
        return new Promise(function (resolve, reject) {
            let url = config.formsApi + "/data/save-ecs/" + removeSlash(patientId);

            if(formName) url += "/"+formName;

            axios.post(url, data).then(function (response) {
                    if (response.status === 200 && response.data.status !== "ERROR") {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async saveDor(data, patientId, formName) {
        return new Promise(function (resolve, reject) {
            let url = config.formsApi + "/data/save-dor/" + removeSlash(patientId);

            if(formName) url += "/"+formName;

            axios.post(url, data).then(function (response) {
                    if (response.status === 200 && response.data.status !== "ERROR") {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async previewDor(data, patientId, formName) {
        return new Promise(function (resolve, reject) {
            let url = config.formsApi + "/data/preview-dor/" + removeSlash(patientId);

            if(formName) url += "/"+formName;

            axios.post(url, data,
                {
                    responseType: "blob",
                    mode: "no-cors",
                    headers: {"Access-Control-Allow-Origin": "*"},
                }).then(function (response) {

                    if (response.status === 200 && response.data.status !== "ERROR") {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static getFormList(patientId, attendIds, episodeNumber, formsToOpen, signal) {
        return new Promise(function (resolve, reject) {
            axios.post(config.formsApi + "/data/listForAttendance/" + removeSlash(patientId), {
                        forms: formsToOpen,
                        attendIds: attendIds,
                        episodeNumber: episodeNumber,
                    },
                    {mode: "no-cors", headers: {"Access-Control-Allow-Origin": "*", signal: signal}})
                .then(function (response) {
                    if (response.status === 200) {
                        resolve(response.data.forms);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    if (error?.message !== "canceled") {
                        reject(error);
                    }
                });
        });
    }

    /**
     * @param {Object} data Post object. Max date range is 31 days, if search by patient id and AttendanceId then date range is optional.
     * @param {string} [data.from] Search from date.
     * @param {string} [data.to] Search to date.
     * @param {string} [data.patient] Patient Hospital Number.
     * @param {string} [data.attendanceId] Patient Attendance Id.
     * @param {string[]} data.forms specify the forms ID in array.
     * @param [signal] AbortController signal
     */
    static async getCompletedForms(data, signal) {
        return new Promise(function (resolve, reject) {
            axios.post(config.formsApi + '/data/getCompletedForms', data, {signal})
                .then(function (response) {
                    if (response.status === 200 && response.data.status !== 'ERROR') {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async generatePdf(ptId, form) {
        return new Promise(function (resolve, reject) {
            axios.post(config.formsApi + `/data/pdf-preview/${removeSlash(ptId)}/${form?.__form}`,
                    {data: form},
                    {
                        responseType: "blob",
                        mode: "no-cors",
                        headers: {"Access-Control-Allow-Origin": "*"},
                    }
                )
                .then(function (response) {
                    if (response.status === 200 && response.data.status !== "ERROR") {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }

    static async generateHtml(ptId, form) {
        return new Promise(function (resolve, reject) {
            axios.post(config.formsApi + `/data/html-preview/${removeSlash(ptId)}/${form?.__form}`,
                    {data: form},
                    {
                        responseType: "blob",
                        mode: "no-cors",
                        headers: {"Access-Control-Allow-Origin": "*"},
                    }
                )
                .then(function (response) {
                    if (response.status === 200 && response.data.status !== "ERROR") {
                        resolve(response.data);
                    } else {
                        resolve(null);
                    }
                })
                .catch(function (error) {
                    reject(error);
                });
        });
    }


}

export default APIForm;